import { FactiiiRequirement } from '@shared/all/domains/factiiis';

import type { CameraFactiiiContext } from './composeUpload.types';

/**
 * The watermark context for a factiii photo, or null when the photo must not
 * be watermarked. Only a factiii with the CAMERA requirement brands its
 * photos: the avatar baked into the image says "taken through this factiii's
 * camera", so a photo attached to any other factiii uploads clean. The server
 * enforces the same rule (uploads.getUploadUrls answers 400 otherwise); this
 * keeps a caller from asking in the first place. See .specs/watermarking.md.
 */
export const cameraFactiiiFor = (factiii: {
  factiiiId: number;
  avatarKey: string | null;
  requirements: readonly string[];
}): CameraFactiiiContext | null =>
  factiii.requirements.includes(FactiiiRequirement.CAMERA)
    ? { factiiiId: factiii.factiiiId, factiiiAvatarKey: factiii.avatarKey }
    : null;
